import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Popconfirm } from "antd";
import { endTransactionAsGhostMutation } from "../../../services/client/@tanstack/react-query.gen";
import { useNotify } from "../../util-components/Notifications/notifications";
import { DisableForViewer } from "../../common/DisableForViewer";
import { formatDateTime } from "../../../util/formatDate";

export const EndAsGhostButton: React.FC<{
  siteId: string;
  transactionId: string;
}> = ({ siteId, transactionId }) => {
  const notify = useNotify();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...endTransactionAsGhostMutation(),
    onSuccess: ({ stop_time }) => {
      void queryClient.invalidateQueries({
        predicate: ({ queryKey }) =>
          (queryKey[0] as { _id?: string })._id ===
          "getTransactionsWithEventsForSite",
      });
      notify({
        type: "success",
        message: "Transaction ended",
        description: `Ended as ghost transaction at ${formatDateTime(stop_time)}.`,
      });
    },
    onError: () => {
      notify({
        type: "error",
        message: "Failed to end transaction as ghost",
      });
    },
  });

  return (
    // Keeps clicks from toggling the row's expansion.
    <span onClick={(event) => event.stopPropagation()}>
      <Popconfirm
        title="End this transaction as a ghost transaction?"
        description="The stop time is the last moment it charged. This can't be undone."
        okText="End transaction"
        okButtonProps={{ danger: true }}
        onConfirm={() =>
          mutation.mutate({
            path: { site_id: siteId, transaction_id: transactionId },
          })
        }
      >
        <DisableForViewer>
          <Button danger size="small" loading={mutation.isPending}>
            End as ghost
          </Button>
        </DisableForViewer>
      </Popconfirm>
    </span>
  );
};
